<div class="shadow transitionEffectAll600 mx-0 d-none d-lg-block p-0"
    [ngClass]="{ 'columnMax' : this.sideBarSize === 'max','columnMin' : this.sideBarSize === 'min', 'columnZero' : auth.currentUserIDSig()?.uid == null}"
    *transloco="let t">
    <div class="new-sidebar pt-2">
        <!-- <div class="sidebar-dark pt-2"> -->
        @if(showSpinner || !this.auth.currentLangSig()?.lang) {
        <div class="row my-5">
            <div class="col text-center">
                <div class="svl-ripple">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        }
        @if (!showSpinner && this.auth.currentLangSig()?.lang) {
        <!-- <div class="sidebarItem row align-items-center" routerLink="/input" routerLinkActive="sidebarItemActive"
            title="{{t('menu.selection-input-new-long')}}">
            <div class="d-flex">
                <div class="sidebarItemIcon">
                        <span class="material-symbols-outlined iconSize">add_circle</span>
                    </div>
                <div class="sidebarItemDescription">
                    {{t('menu.selection-input-new-long')}}
                </div>
            </div>
        </div>
        <div class="sidebarItem row align-items-center" routerLink="/dashboard" routerLinkActive="sidebarItemActive"
            title="{{t('menu.selection-dashboard')}}">
            <div class="icon-link">
                <div class="sidebarItemIcon text-center">
                    <span class="material-symbols-outlined iconSize align-items-center">planner_review</span>
                </div>
                <div class="sidebarItemDescription">
                    {{t('menu.selection-dashboard')}}
                </div>
            </div>
        </div>
        <div class="sidebarItem row align-items-center" routerLink="/categories" routerLinkActive="sidebarItemActive"
            title="{{t('menu.selection-categories')}}">
            <div class="icon-link">
                <div class="sidebarItemIcon text-center">
                    <span class="material-symbols-outlined iconSize align-items-center">view_column</span>
                </div>
                <div class="sidebarItemDescription">
                    {{t('menu.selection-categories')}}
                </div>
            </div>
        </div>
        <div class="sidebarItem row align-items-center" routerLink="/transactions" routerLinkActive="sidebarItemActive"
            title="{{t('menu.selection-transactions')}}">
            <div class="icon-link">
                <div class="sidebarItemIcon text-center">
                    <span class="material-symbols-outlined iconSize align-items-center">receipt_long</span>
                </div>
                <div class="sidebarItemDescription">
                    {{t('menu.selection-transactions')}}
                </div>
            </div>
        </div>
        <div class="sidebarItem row align-items-center" routerLink="/budget" routerLinkActive="sidebarItemActive"
            title="{{t('menu.selection-budget')}}">
            <div class="icon-link">
                <div class="sidebarItemIcon text-center">
                    <span class="material-symbols-outlined iconSize align-items-center">savings</span>
                </div>
                <div class="sidebarItemDescription">
                    {{t('menu.selection-budget')}}
                </div>
            </div>
        </div>
        <div class="row sidebarCollapser">
            <div class="col">
                @if (this.sideBarSize === 'max') {
                <i class="material-symbols-outlined" (click)="sideBarCollapser(this.sideBarSize)">chevron_left</i>
                }
                @if (this.sideBarSize === 'min') {
                <i class="material-symbols-outlined" (click)="sideBarCollapser(this.sideBarSize)">chevron_right</i>
                }
            </div>
        </div>
        <div class="bottom-item">

            <div class="sidebarItem row align-items-center" title="{{t('menu.selection-contact')}}"
                data-bs-toggle="modal" data-bs-target="#contactModal">
                <div class="icon-link">
                    <div class="sidebarItemIcon text-center">
                        <span class="material-symbols-outlined iconSize align-items-center">mail</span>
                    </div>
                    <div class="sidebarItemDescription">
                        {{t('menu.selection-contact')}}
                    </div>
                </div>
            </div>

            <div class="sidebarItem row align-items-center" title="{{t('menu.selection-signout')}}"
                data-bs-toggle="modal" data-bs-target="#signOutModal">
                <div class="icon-link">
                    <div class="sidebarItemIcon text-center">
                        <span class="material-symbols-outlined iconSize align-items-center">logout</span>
                    </div>
                    <div class="sidebarItemDescription">
                        {{t('menu.selection-signout')}}
                    </div>
                </div>
            </div>

        </div> -->

        <div class="sidebar-top-section">
            <div class="sidebar-item row align-items-center" routerLink="/input" routerLinkActive="sidebar-item-active"
                title="{{t('menu.selection-input-new-long')}}">
                <div class="d-flex">
                    <div class="sidebar-item-icon-box">
                        <span class="material-symbols-outlined icon-size">add_circle</span>
                    </div>
                    <div class="sidebar-item-description-box">
                        {{t('menu.selection-input-new-long')}}
                    </div>
                </div>
            </div>
            <div class="sidebar-item row align-items-center" routerLink="/dashboard"
                routerLinkActive="sidebar-item-active" title="{{t('menu.selection-dashboard')}}">
                <div class="icon-link">
                    <div class="sidebar-item-icon-box text-center">
                        <span class="material-symbols-outlined icon-size align-items-center">planner_review</span>
                    </div>
                    <div class="sidebar-item-description-box">
                        {{t('menu.selection-dashboard')}}
                    </div>
                </div>
            </div>
            <div class="sidebar-item row align-items-center" routerLink="/categories"
                routerLinkActive="sidebar-item-active" title="{{t('menu.selection-categories')}}">
                <div class="icon-link">
                    <div class="sidebar-item-icon-box text-center">
                        <span class="material-symbols-outlined icon-size align-items-center">view_column</span>
                    </div>
                    <div class="sidebar-item-description-box">
                        {{t('menu.selection-categories')}}
                    </div>
                </div>
            </div>
            <div class="sidebar-item row align-items-center" routerLink="/transactions"
                routerLinkActive="sidebar-item-active" title="{{t('menu.selection-transactions')}}">
                <div class="icon-link">
                    <div class="sidebar-item-icon-box text-center">
                        <span class="material-symbols-outlined icon-size align-items-center">receipt_long</span>
                    </div>
                    <div class="sidebar-item-description-box">
                        {{t('menu.selection-transactions')}}
                    </div>
                </div>
            </div>
            <div class="sidebar-item row align-items-center" routerLink="/budget" routerLinkActive="sidebar-item-active"
                title="{{t('menu.selection-budget')}}">
                <div class="icon-link">
                    <div class="sidebar-item-icon-box text-center">
                        <span class="material-symbols-outlined icon-size align-items-center">savings</span>
                    </div>
                    <div class="sidebar-item-description-box">
                        {{t('menu.selection-budget')}}
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebar-bottom-section">
            <div class="sidebar-item row align-items-center" title="{{t('menu.selection-contact')}}"
                data-bs-toggle="modal" data-bs-target="#contactModal">
                <div class="icon-link">
                    <div class="sidebar-item-icon-box text-center">
                        <span class="material-symbols-outlined icon-size align-items-center">mail</span>
                    </div>
                    <div class="sidebar-item-description-box">
                        {{t('menu.selection-contact')}}
                    </div>
                </div>
            </div>

            <div class="sidebar-item row align-items-center" title="{{t('menu.selection-signout')}}"
                data-bs-toggle="modal" data-bs-target="#signOutModal">
                <div class="icon-link">
                    <div class="sidebar-item-icon-box text-center">
                        <span class="material-symbols-outlined icon-size align-items-center">logout</span>
                    </div>
                    <div class="sidebar-item-description-box">
                        {{t('menu.selection-signout')}}
                    </div>
                </div>
            </div>
            <div class="sidebar-item row align-items-center"  title="{{t('menu.selection-size')}}"
                (click)="sideBarCollapser(this.sideBarSize)">
                <div class="icon-link">
                    <div class="sidebar-item-icon-box text-center">
                        @if (this.sideBarSize === 'max') {
                        <span class="material-symbols-outlined icon-size align-items-center">arrow_menu_close</span>
                        }
                        @if (this.sideBarSize === 'min') {
                        <span class="material-symbols-outlined icon-size align-items-center">arrow_menu_open</span>
                        }
                    </div>
                    <div class="sidebar-item-description-box">
                        @if (this.sideBarSize === 'max') {
                        {{t('menu.selection-collapse')}}
                        }
                        @if (this.sideBarSize === 'min') {
                        {{t('menu.selection-expand')}}
                        }

                    </div>
                </div>
            </div>
        </div>
        }

    </div>
</div>